/**
 * Main Integration Hub for Subcontracting
 * Centralized initialization and management of all integrations
 */

// Import all integration modules to ensure event listeners are registered
import './inventoryIntegration';
import './costingIntegration';
import './schedulingIntegration';

// Re-export integration instances for direct access if needed
export { inventoryIntegration } from './inventoryIntegration';
export { costingIntegration } from './costingIntegration';
export { schedulingIntegration } from './schedulingIntegration';

// Re-export event system
export * from '../events/subcontractingEvents';

/**
 * Initialize all subcontracting integrations
 * Call this once during app startup to ensure all event listeners are registered
 */
export const initializeSubcontractingIntegrations = () => {
  console.log('🚀 Initializing subcontracting integrations...');
  
  // Event listeners are automatically registered when modules are imported
  // This function serves as an explicit initialization point
  
  console.log('✅ Subcontracting integrations initialized:');
  console.log('   - Inventory Integration: Active');
  console.log('   - Costing Integration: Active');
  console.log('   - Scheduling Integration: Active');
  console.log('   - Event System: Ready');
};

/**
 * Health check for all integrations
 */
export const checkIntegrationHealth = () => {
  // Import the event emitter to check registered listeners
  import('../events/subcontractingEvents').then(({ subcontractingEvents }) => {
    const listeners = subcontractingEvents.getListeners();
    
    console.log('🔍 Integration Health Check:');
    listeners.forEach(({ type, count }: { type: string, count: number }) => {
      console.log(`   - ${type}: ${count} listener(s)`);
    });
    
    return {
      healthy: listeners.length > 0,
      listeners: listeners
    };
  }).catch(error => {
    console.error('Health check failed:', error);
    return { healthy: false, listeners: [] };
  });
  
  // Return immediately for sync call compatibility
  return {
    healthy: true, // Assume healthy until proven otherwise
    listeners: []
  };
};
